import Client from '@/repositories/AxiosClient';
const resource = '/core/user';

export default {
    getEditorFor() {
        return Client().get(`${resource}/editor`);
    },
};
